import { Checkbox } from "@king-ict/eupisi-ui/components";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { FormCard } from "../../../components/FormControls/FormCard";
import { useAuth } from "../../../hooks/auth/useAuth";
import { Role } from "../../../models";

const ALLOWED_ROLES_TO_EDIT = [
  Role.CAS,
  Role.Helpdesk,
  Role.CountyAdministrator,
  Role.CountyLeader,
];

interface IProps {
  isReligious: boolean;
  isMinority: boolean;
  enrollmentInstitution: boolean | null;
  readonly?: boolean;
  onChange?: (value: boolean) => void;
}

export function EnrollmentInstitutionFormCard({
  isReligious,
  isMinority,
  enrollmentInstitution,
  readonly = false,
  onChange,
}: IProps) {
  const { t } = useTranslation();
  const { currentRole } = useAuth();

  if (!isReligious && !isMinority) {
    return null;
  }

  const isAllowedToEdit = ALLOWED_ROLES_TO_EDIT.includes(
    currentRole?.role || 0
  );

  return (
    <FormCard cardTitle={t("common.institutionDetails.enrollmentInstitution")}>
      <Row>
        <Col md={12}>
          <Checkbox
            label={t("common.institutionDetails.isEnrollmentInstitution")}
            checked={!!enrollmentInstitution}
            onChange={(e) => onChange?.(e.target.checked)}
            disabled={readonly || !isAllowedToEdit}
          />
        </Col>
      </Row>
    </FormCard>
  );
}
